export default __webpack_public_path__ + "src/assets/container_icons/8YARD.png";